import Vue from "vue";
import { Message } from "element-ui";
import { storage } from "@/CommonDP/utils";
import { isObject } from "lodash-es";
// import { findLastIndex } from "lodash";
export const FLOW_TYPE = {
  "add": 1, // 新增
  "edit": 2, // 审批
  "view": 3, // 查看
  "draft": 4, // 暂存
  "again": 5 // 重新发起
};
// map 结构，所有的流程
const approveInit = new Map();

export class FlowInitData {
  user = require("@/store/index").default.state.user;
  flowType=""; // FLOW_TYPE的映射: 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
  currentVersionId="";
  flowDefinitionId="";
  flowInstanceId="";
  flowKey="";
  enterpriseId="";
  prjId = "";
  detail={};// 存放此流程的基本信息 大部分通过/flowNew/get接口查的信息 暂存通过flow/draft/detail查
  basicdata={} // 基本信息的表单数据
  nodeList=[]; // 没有处理的流程节点列表
  formProcessor=[] // 表单处理人 可破坏流程处理人相应节点的审批人
  formFieldPermissionList=[];// 流程节点的表单权限列表
  fileInfoList=[]; // 附件文件列表
  vform=null
  constructor(option) {
    // 流程完毕后的抄送人
    // option.flowDefinitionCcList = option?.flowDefinitionCcList?.length > 0 ? option.flowDefinitionCcList : option.ccList;
    if (option) {
      this.flowType = option.flowType;
      this.currentVersionId = option.currentVersionId;
      this.flowDefinitionId = option.flowDefinitionId;
      this.flowInstanceId = option.flowInstanceId;
      this.flowKey = option.flowKey;
      this.enterpriseId = option.enterpriseId;
      this.prjId = option.prjId;
      this.basicdata = option.json || { fileInfoList: [] };
      this.basicdata.fileInfoList = [...this.basicdata?.fileInfoList || [], ...option?.fileInfoList || []];// 对自定义的表单附件做处理
      this.detail = option;
      this.formFieldPermissionList = option.formFieldPermissionList || [];
      Vue.observable(this);
    }
  }
  setPrjId(val) {
    this.prjId = val;
  }
  getPrjId() {
    return this.prjId;
  }
  setBusinessId(businessId = "") {
    this.detail.businessId = businessId;
  }
  // 流程的基本信息
  getMessage() {
    return this.detail;
  }
  // 流程的表单数据
  setFormData(data, type = "lowcode") {
    if (type === "lowcode") {
      this.basicdata = data;
    } else { // 自定义的流程表单会有公共的文件预览组件fileInfoList
      const { fileInfoList = [] } = this.basicdata;
      this.basicdata = { ...data, fileInfoList };
    }
  }
  getFormData() {
    return getArrayData(this.basicdata);
  }
  setFileInfoList(val) {
    this.fileInfoList = val || [];
  }
  addStartAttachedFiles(array) {
    const flowFileList = this.basicdata?.fileInfoList;
    for (const iterator of array) {
      if (flowFileList.some(({ fileId, fileName }) => iterator.fileName === fileName && iterator.fileId === fileId)) {
        Message.warning(`${iterator.fileName}上传失败，已存在同名文件`);
      } else {
        this.basicdata.fileInfoList.push(iterator);
      }
    }
  }
  // 自定义页面查看文件列表
  getFileInfoList() {
    return this.basicdata?.fileInfoList || [];
  }
  deleteStartAttachedFiles(val) {
    const fileInfoList = this.basicdata?.fileInfoList;
    this.basicdata.fileInfoList = fileInfoList.filter((e) => e.fileId !== val.fileId);
  }
  // 流程的节点处理
  setFlowNodeDtoList(val) {
    this.nodeList = val;
  }
  addFlowNodeHistoryList(list) {
    // const newNodeList = this.nodeList?.map((e, index) => {
    //   if (index === 0) { return { ...e }; }
    //   // 如果不是第1个节点，则优先从历史记录中获取审批人
    //   const num = findLastIndex(list, i => i.flowNodeDefinitionId === e.flowNodeDefinitionId);
    //   const assigneeList = list[num]?.assigneeList || [];
    //   if (assigneeList.length) {
    //     return { ...e, assigneeList };
    //   } else {
    //     return { ...e };
    //   }
    // });
    this.nodeList = [...list, ...this.nodeList];
  }
  setFormProcessor(val) {
    if (Array.isArray(val)) {
      this.formProcessor = this.formProcessor.concat(val);
    } else {
      this.formProcessor.push(val);
    }
  }
  getFlowNodeDtoList() {
    if (Array.isArray(this.formProcessor)) {
      const idList = [];
      for (const iterator of this.formProcessor) {
        const { nodeIndex = "", nodeKey = "", nodeName = "", nodeType = 0, usersList = [] } = iterator;
        const flowNodeDefinitionId = getFlowNodeDefinitionId(nodeIndex, nodeKey, nodeName, this.nodeList.filter(e => !e.id.startsWith("old")));
        if (idList.some(e => e.id === flowNodeDefinitionId)) {
          for (const iterator of idList) {
            if (iterator.id === flowNodeDefinitionId) {
              iterator.list = usersList;
            }
          }
        } else {
          idList.push({ id: flowNodeDefinitionId, nodeType, list: usersList });
        }
      }
      this.nodeList.forEach(element => {
        if (idList.some(e => e.id === element.flowNodeDefinitionId)) {
          const array = idList.find(e => e.id === element.flowNodeDefinitionId);
          const { nodeType, list: usersList } = array;
          nodeType === 0 ? element.assigneeList = usersList : element.ccList = usersList;
        }
      });
    } else if (Object.keys(this.formProcessor).length) { // 估计用不到了
      const { nodeIndex = "", nodeKey = "", nodeName = "", usersList = [] } = this.formProcessor;
      const flowNodeDefinitionId = getFlowNodeDefinitionId(nodeIndex, nodeKey, nodeName, this.nodeList);
      this.nodeList.forEach(element => {
        if (element.flowNodeDefinitionId === flowNodeDefinitionId) {
          element.assigneeList = usersList;
        }
      });
    }
    return this.nodeList || [];
  }
  // 添加流程人员
  addFlowNodeDtoList(flowNodeDefinitionId, users, type) {
    this.nodeList?.forEach(element => {
      if (element.flowNodeDefinitionId === flowNodeDefinitionId) {
        if (type === "ass") {
          element.assigneeList = users;
        } else {
          element.ccList = users;
        }
      }
    });
  }
  // 删除流程人员
  deleteFlowNodeDtoList(flowNodeDefinitionId, id, type) {
    this.nodeList?.forEach(element => {
      if (element.flowNodeDefinitionId === flowNodeDefinitionId && element.isHistoryFlow !== 0) {
        if (type === "ass") {
          // 历史节点不处理，只处理新增的节点
          element.assigneeList = element.assigneeList.filter((e) => e.userId !== id);
        } else {
          element.ccList = element.ccList.filter((e) => e.userId !== id);
        }
      }
    });
  }
  // 流程完后抄送人
  setCcUserIdList(users) {
    this.detail.ccList = users;
  }
  // 删除流程完毕后的抄送人
  deleteAssUser(user) {
    this.detail.ccList = this.detail.ccList.filter((e) => e.userId !== user);
  }
  getAddNodeList() {
    const nodeList = this.getFlowNodeDtoList();
    return nodeList.filter(e => !e.isHistory).map(row => {
      const assigneeList = row.assigneeList.map((e) => {
        return {
          ...e,
          type: 0 // 用户类型 0：审批人(默认) 1：抄送人
        };
      });
      const ccList = row.ccList.map((e) => {
        return {
          ...e,
          type: 1 // 用户类型 0：审批人(默认) 1：抄送人
        };
      });
      return {
        flowNodeDefinitionId: row.flowNodeDefinitionId,
        assigneeSelectionStrategy: row.assigneeSelectionStrategy,
        userDtoList: [...assigneeList, ...ccList]
      };
    });
  }
}
function getArrayData(object) {
  if (!isObject(object)) return object;
  const newObject = {};
  for (const [key, value] of Object.entries(object)) {
    if (Array.isArray(value)) {
      // 子表
      const arr = [];
      for (const iterator of value) {
        const item = getArrayData(iterator);
        arr.push(item);
      }
      newObject[key] = arr;
    } else {
      // 普通数据
      newObject[key] = stringToArray(value);
    }
  }
  return newObject;
}
function stringToArray(str) {
  try {
    if (typeof str === "string" && Array.isArray(JSON.parse(str))) {
      return JSON.parse(str);
    } else {
      return str;
    }
  } catch (error) {
    return str;
  }
}
export function getApprove(uuidKey, defaultValue) {
  return approveInit.has(uuidKey) ? approveInit.get(uuidKey) : defaultValue;
}
export function deleteApprove(uuidKey) {
  approveInit.delete(uuidKey);
  const flowArray = JSON.parse(storage.get("flowId")) || [];
  const array = flowArray.filter(e => e.id !== uuidKey);
  storage.set("flowId", JSON.stringify(array));
}
export function setApprove(uuidKey, value) {
  const old = approveInit.get(uuidKey);
  const newValue = old ? Object.assign(old, value) : value;
  approveInit.set(uuidKey, newValue);
  const { detail: { flowInstanceId = "" }} = newValue;
  if (flowInstanceId) {
    const flowArray = JSON.parse(storage.get("flowId")) || [];
    const obj = { id: uuidKey, value: flowInstanceId };
    flowArray.push(obj);
    storage.set("flowId", JSON.stringify(flowArray));
  }
}
/**
 * 初始化审批流程 Map结构
 * @param {string} uuidKey uuid此弹框的唯一标识
 * @param {object} data 流程的基本信息
 */
export function initApprovalFlowKey(uuidKey, data) {
  const value = new FlowInitData(data);
  setApprove(uuidKey, value);
  console.log("approveInit", approveInit);
}

function getFlowNodeDefinitionId(nodeIndex, nodeKey, nodeName, list) {
  if (typeof nodeIndex === 'number' || nodeIndex) {
    return list[Number(nodeIndex)]?.flowNodeDefinitionId;
  } else if (nodeKey) {
    return list.find((item) => item?.nodeKey === nodeKey)?.flowNodeDefinitionId;
  } else if (nodeName) {
    return list.find((item) => item?.nodeName === nodeName)?.flowNodeDefinitionId;
  }
}
